import React, { useEffect, useRef, useState } from 'react'
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import AddIcon from '@mui/icons-material/Add';
import CustomSearch from '../../../components/CustomSearch';
import { useTranslation } from 'react-i18next';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import { CustomAdvancedMenuList } from '../../../components/StyledComponents';
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import ExportIcon16pxSvg from '../../../assets/images/icons/ExportIcon16pxSvg';
import { useLocation } from 'react-router-dom';
import { eachDayOfInterval, endOfMonth, startOfMonth, startOfWeek } from 'date-fns';
import VisitorEventsCalendar from './VisitorEventsCalendar';
import VisitorEventLogGridInfoTable from './VisitorEventLogGridInfoTable';
import VisitorImagesGridInfoTable from './VisitorImagesGridInfoTable';
import AddEventLogDialog from './AddEventLogDialog';
import { endOfDay, startOfDay } from "date-fns";
import CalendarToday from "../../../assets/images/icons/CalendarToday";
import CustomDateRangePicker from "../../../components/CustomDateRangePicker";
import { useAuth } from "../../../context/AuthContext";
import { LoadingProvider, useLoading } from '../../../context/LoadingContext';
import { getEventsLogVisitors, getEventsVisitors } from '../../../axios/Visitor/VisitorApi';
import CustomDateTimePicker from '../../../components/CustomDateTimeRangePicker';
import { exportEventsLogVisitorsCSV } from '../../../axios/Visitor/VisitorApi';
import { toast } from 'react-toastify';
import ImportIcon16pxSvg from '../../../assets/images/icons/ImportIcon16pxSvg';

const EventLogTab = ({ refreshData, onRefresh, refresh, dataInfo }) => {
    const [openAdvanced, setOpenAdvanced] = useState(false);
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const { myData } = location.state || {};
    const [dispalyWeek, setDispalyWeek] = useState(0);
    const currentLang = i18n.language;
    const [selectedDate, setSelectedDate] = useState(
        myData && !isNaN(new Date(myData).getTime()) ? new Date(myData) : new Date()
    );
    const [selectedRow, setSelectedRow] = useState({});
    const [show, hide] = useLoading();

    const [addEventLogOpen, setAddEventLogOpen] = useState(false);

    const { genaralSettingDateFormat, dateTimeFormat } = useAuth();

    const [selectedDateTime, setSelectedDateTime] = useState({
        startDate: startOfDay(new Date()),
        endDate: startOfDay(new Date()),
    });

    const [data, setData] = useState([]);
    const [dataUser, setDataUser] = useState([]);
    const [logTotalPages, setLogTotalPages] = useState(1);
    const [logPageSize, setLogPageSize] = useState(50);

    const handlePaginationChange = ({ totalPages, pageSize }) => {
        setLogTotalPages(totalPages);
        setLogPageSize(pageSize);
    };

    function getCurrentTimestamp() {
        const now = new Date();
        const yyyy = now.getFullYear();
        const MM = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const HH = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');
        return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
    }

    const exportEventLogs = async () => {
        setOpenAdvanced(false);

        const payload = {
            eventId: dataInfo?.id || null,
            isError: null,
            isEnabled: null,
            pageNo: logTotalPages,
            recordPerPage: logPageSize,
            from: startOfDay(selectedDateTime.startDate).toISOString(),
            to: endOfDay(selectedDateTime.endDate).toISOString(),
            langId: localStorage.getItem("i18nextLngId"),
            formatDate: dateTimeFormat,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        try {
            show();
            const response = await exportEventsLogVisitorsCSV(payload);

            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `${t('export.visitor-event-logs')}_${dataInfo?.name || 'event'}_${getCurrentTimestamp()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            toast.error(error?.response?.data?.message || t('common.something-went-wrong'));
        } finally {
            hide();
        }
    };

    const handleGoToToday = () => {
        const today = startOfDay(new Date());

        setSelectedDateTime({
            startDate: today,
            endDate: today,
        });
    };

    const calculateDisplayedWeeks = (date, weekStartsOnAbbr) => {
        let weekDayAbbrToIndex = {}
        if (currentLang === 'vi') {
            weekDayAbbrToIndex = {
                CN: 0,
                T2: 1,
                T3: 2,
                T4: 3,
                T5: 4,
                T6: 5,
                T7: 6,
            };
        } else {
            weekDayAbbrToIndex = {
                Sun: 0,
                Mon: 1,
                Tue: 2,
                Wed: 3,
                Thu: 4,
                Fri: 5,
                Sat: 6,
            };
        }

        const weekStartsOn = weekDayAbbrToIndex[weekStartsOnAbbr];
        if (weekStartsOn === undefined) {
            throw new Error("Invalid week start day. Use 'Sun', 'Mon', 'Tue', etc.");
        }

        const firstDayOfMonth = startOfMonth(date);
        const lastDayOfMonth = endOfMonth(date);

        // ngày đầu tuần thật sự chứa ngày 1 của tháng
        const calendarStartDate = startOfWeek(firstDayOfMonth, { weekStartsOn });

        // ngày cuối cùng trong tháng có thể tràn sang tuần sau
        const daysInGrid = eachDayOfInterval({
            start: calendarStartDate,
            end: lastDayOfMonth,
        });

        // cộng thêm ngày để đủ lưới 35 hoặc 42 ngày
        const totalCells = daysInGrid.length <= 35 ? 35 : 42;
        setDispalyWeek(totalCells / 7)
        return totalCells / 7;
    };

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const fetchData = async () => {
        const payload = {
            eventId: dataInfo?.id || null,
            pageNo: 1,
            recordPerPage: 10000,
            status: "APPROVED",
        };
        try {
            show();
            const response = await getEventsVisitors(payload);

            setDataUser(response?.data?.data || []);


        } catch (error) {
            console.error(error);
        } finally {
            hide();
        }
    };

    useEffect(() => {
        fetchData();
    }, [dataInfo?.id, refreshData]);

    return (
        <>
            <div>
                <div className="flex items-center gap-3">
                    {/* TODAY */}
                    <div
                        className="flex items-center justify-center w-10 h-10 cursor-pointer select-none border border-[#E5E7EB] rounded-[6px]"
                        onClick={handleGoToToday}
                    >
                        <CalendarToday
                            fontSize="small"
                            className="text-[#1F2937]"
                        />
                    </div>

                    {/* RANGE PICKER */}
                    <div className="min-w-[280px]">
                        <CustomDateTimePicker
                            mode="range"
                            disableTime
                            showOnlyDate
                            value={[
                                selectedDateTime.startDate,
                                selectedDateTime.endDate,
                            ]}
                            onChange={([startDate, endDate]) => {
                                setSelectedDateTime({
                                    startDate,
                                    endDate,
                                });
                            }}
                        />
                    </div>

                    {/* SEARCH */}
                    <div className="flex-1">
                        <CustomSearch
                            onSearchChange={handleQuickFilterChange}
                        />
                    </div>

                    {/* BUTTON GROUP */}
                    <div className="flex rounded-md border border-[#DBE8FF] overflow-hidden bg-[#0057FF] h-10">
                        {/* ADD */}
                        <button
                            className="flex items-center gap-2 px-4 h-full text-[#FCFCFC] hover:bg-[#00308C] transition"
                            onClick={() => setAddEventLogOpen(true)}
                        >
                            <AddIcon />
                            {t("button.add")}
                        </button>

                        {/* DROPDOWN */}
                        <button
                            ref={anchorRefAdvanced}
                            id="advanced-button"
                            aria-haspopup="true"
                            onClick={handleToggleAdvanced}
                            className="px-3 h-full flex items-center justify-center text-[#FCFCFC] hover:bg-[#00308C] transition"
                        >
                            <ArrowDropDownIcon />
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 2xl:grid-cols-1 gap-4 2xl:gap-5 mt-4">
                    <div className=''>
                        <LoadingProvider>
                            <VisitorEventLogGridInfoTable selectedDateTime={selectedDateTime} dataInfo={dataInfo} setData={setData} data={data} onRowClick={setSelectedRow} refreshData={refreshData} onRefresh={onRefresh} refresh={refresh} onPaginationChange={handlePaginationChange} />
                        </LoadingProvider>  
                    </div>
                </div>
            </div >

            {addEventLogOpen && <AddEventLogDialog dataInfo={dataInfo} data={dataUser} selectedDate={selectedDate} onClose={() => setAddEventLogOpen(false)} refreshData={refreshData} onRefresh={onRefresh} refresh={refresh} />}

            <Popper
                open={openAdvanced}
                anchorEl={anchorRefAdvanced.current}
                placement="bottom-start"
                transition
                disablePortal
                className="z-10"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "left top" : "left bottom",
                        }}
                    >
                        <Paper style={{ borderRadius: "8px", }}>
                            <ClickAwayListener onClickAway={handleCloseAdvanced}>
                                <CustomAdvancedMenuList
                                    id="advanced-menu"
                                    aria-labelledby="advanced-button"
                                >
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <ImportIcon16pxSvg />
                                            <p>{t("button.import-data")}</p>
                                        </Link>
                                    </MenuItem>

                                    <MenuItem
                                        onClick={exportEventLogs}
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                        }}
                                    >
                                        <Link>
                                            <ExportIcon16pxSvg />
                                            <p>{t("button.export-data")}</p>
                                        </Link>
                                    </MenuItem>
                                </CustomAdvancedMenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default EventLogTab